import { DatePipe } from '@angular/common';
import { Component, inject, OnInit, TemplateRef, viewChild } from '@angular/core';

import { ConfirmationModalComponent } from '@shared/components/modals/confirmation-modal/confirmation-modal.component';
import { MAP_CUSTOM_CONTROLS } from '@shared/components/territory-map/constants/map-controls.token';
import { TerritoryMapService } from '@shared/components/territory-map/services';
import { TerritoryMapComponent } from '@shared/components/territory-map/territory-map.component';
import { LocatorSidebarComponent } from './components/locator-sidebar/locator-sidebar.component';
import { LOCATOR_DATA } from './constants/locator.constants';
import { LocatorService } from './services/locator.service';

export interface TerritoryPopupData {
    territoryName: string;
    assignedDealer: string;
    totalArea: number;
    longitude: number;
    latitude: number;
    createdDate: string;
    status: string;
    category: string;
    state: string;
}

const STATUS_COLOR: Record<string, string> = {
    Active: '#8DCB2C',
    Inactive: '#9E9E9E',
    Pending: '#FF9800',
};

@Component({
    selector: 'app-locator',
    imports: [TerritoryMapComponent, ConfirmationModalComponent, DatePipe],
    templateUrl: './locator.component.html',
    styleUrl: './locator.component.scss',
    providers: [
        {
            provide: MAP_CUSTOM_CONTROLS,
            useValue: LocatorSidebarComponent,
        },
    ],
})
export class LocatorComponent implements OnInit {
    protected locatorService = inject(LocatorService);
    private territoryMapService = inject(TerritoryMapService);

    /**
     * Queries the #territoryPopupTpl template variable.
     * Property name differs from the template variable to avoid Angular resolving the
     * template variable instead of this signal when referenced in the template.
     */
    protected popupTpl = viewChild<TemplateRef<TerritoryPopupData>>('territoryPopupTpl');

    public ngOnInit(): void {
        const territories = LOCATOR_DATA.map((t, idx) => ({
            id: idx,
            name: t.territoryName,
            color: STATUS_COLOR[t.status] ?? '#8DCB2C',
            territory: (t.latitude as number[]).map(
                (lat, i) => [lat, (t.longitude as number[])[i]] as [number, number],
            ),
            popupData: {
                territoryName: t.territoryName,
                assignedDealer: t.assignedDealer,
                totalArea: t.totalArea,
                longitude: (t.longitude as number[])[0],
                latitude: (t.latitude as number[])[0],
                createdDate: t.createdDate,
                status: t.status,
                category: t.category,
                state: t.state,
            },
        }));

        this.territoryMapService.locatorTerritories.set(territories);
    }
}
